import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "company_information"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "ci_title"
};
const _hoisted_4 = {
  key: 0,
  class: "ci_info"
};
const _hoisted_5 = {
  class: "ci_info_item"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "ci_info_item_title"
}, "公司名称", -1);

const _hoisted_7 = {
  class: "ci_info_item"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "ci_info_item_title"
}, "公司logo", -1);

const _hoisted_9 = {
  class: "ci_info_item"
};

const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "ci_info_item_title"
}, "客服邮箱", -1);

const _hoisted_11 = {
  key: 1,
  class: "ci_info"
};
const _hoisted_12 = {
  class: "ci_info_item"
};

const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "ci_info_item_title"
}, "基地名称", -1);

const _hoisted_14 = {
  key: 1
};

const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", {
  class: "ci_title"
}, "编辑公司信息", -1);

const _hoisted_16 = {
  class: "ci_info_footer"
};
import UploadSinglePicture from "@com/upload/UploadSinglePicture.vue";
import { Edit } from "@element-plus/icons-vue";
import $ from "@util/base";
import api from "@api/company";
import { ref, computed } from "vue";
import useAccoutStore from "@store/accout";
export default {
  __name: 'CompanyInformation',

  setup(__props) {
    const accoutStore = useAccoutStore();
    const mainShopLevel = computed(() => {
      return accoutStore.userInfo.mainStore;
    });
    const readOnly = ref(true);
    const data = ref({});
    const formRef = ref("");
    const form = ref({
      name: "",
      logo: "",
      mail: "",
      shopName: ""
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入公司名称",
        trigger: "blur"
      }],
      logo: [{
        required: true,
        message: "请上传公司logo",
        trigger: "blur"
      }],
      mail: [{
        required: true,
        message: "请输入客服邮箱",
        trigger: "blur"
      }, {
        type: 'email',
        message: '请输入正确的邮箱地址',
        trigger: ['blur', 'change']
      }]
    };
    getCompany();

    function getCompany() {
      api.getCompany(val => {
        data.value = $.deepCopy(val);
      });
    }

    function edit() {
      readOnly.value = false;
      form.value = $.deepCopy(data.value);
    }

    function submitForm() {
      formRef.value.validate((valid, fields) => {
        if (valid) {
          api.updateCompany(form.value, val => {
            cancel();
          });
        } else {
          return false;
        }
      });
    }

    function cancel() {
      readOnly.value = true;
      getCompany();
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [readOnly.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createTextVNode(" 公司信息 "), mainShopLevel.value ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: edit,
        type: "primary",
        text: ""
      }, {
        default: _withCtx(() => [_createTextVNode("编辑")]),
        _: 1
      })), [[_directive_auth, _ctx.getCurCode('MODIFY')]]) : _createCommentVNode("", true)]), mainShopLevel.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(data.value.name), 1)]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createVNode(_component_el_image, {
        src: data.value.logo,
        fit: "fill"
      }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(data.value.mail), 1)])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(data.value.shopName), 1)])]))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        rules: rules,
        "label-width": "80px",
        class: "ci_info base_details_form"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "公司名称",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
            placeholder: "请输入"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "公司logo",
          prop: "logo"
        }, {
          default: _withCtx(() => [_createVNode(UploadSinglePicture, {
            modelValue: form.value.logo,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.logo = $event),
            width: 80
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "客服邮箱",
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.mail,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.mail = $event),
            placeholder: "请输入"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
          onClick: submitForm,
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("保存")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        })])]),
        _: 1
      }, 8, ["model"])]))]);
    };
  }

};